import { createFileRoute } from "@tanstack/react-router";

import { ReportGenerationPage } from "@/features/report-generation/components/report-generation-page";

export const Route = createFileRoute("/_authed/_dashboard/admin-tools/reporting")({
  component: ReportGenerationPage,
});
